import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import { getServiceDeskSettingsResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { projectSettingsServicedeskNotificationsCustomerNotificationsRoute } from '@atlassian/jira-router-routes-project-settings-service-desk-customer-notifications-routes/src/projectSettingsServicedeskNotificationsCustomerNotificationsRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { ServiceDeskCustomerNotificationsNextGenRedirect } from './ui/service-desk-customer-notifications-next-gen-redirect/index.tsx';
import { LazyProjectSettingsServiceDeskCustomerNotifications } from './ui/service-desk-customer-notifications/index.tsx';

export const projectSettingsServicedeskNotificationsCustomerNotificationsRouteEntry = createEntry(
	projectSettingsServicedeskNotificationsCustomerNotificationsRoute,
	() => ({
		group: 'project-settings-servicedesk',
		component: ServiceDeskCustomerNotificationsNextGenRedirect,
		layout: serviceProjectLayout,
		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncSidebarServicedesk,
			sidebarId: SIDEBAR_ID.PROJECT_SETTINGS,
		},
		resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],
		forPaint: [LazyAtlassianNavigation, LazyProjectSettingsServiceDeskCustomerNotifications],
	}),
);
